// extracted by mini-css-extract-plugin
module.exports = {"footer":"CardFooter_footer__3aBUW"};